//获取yyyy-mm-dd的时间字符串
export function getZSHGFormatDate(day, seperator1) {
  let date = new Date();
  let tempdate = date.getTime() + 1000 * 60 * 60 * 24 * day;
  date.setTime(tempdate);
  if (seperator1 == undefined) {
    seperator1 = '-';
  }
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month.toString().length == 1) {
    month = '0' + month;
  }
  if (strDate.toString().length == 1) {
    strDate = '0' + strDate;
  }
  let currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}
// 时间戳 转变成 时间字符串yyyy-mm-dd
export function fmDate(timec) {
  if (timec == '') {
    return '';
  }
  let obj = Number(timec);
  let date = new Date(obj);
  let y = 1900 + date.getYear();
  let m = '0' + (date.getMonth() + 1);
  let d = '0' + date.getDate();
  return (
    y +
    '-' +
    m.substring(m.length - 2, m.length) +
    '-' +
    d.substring(d.length - 2, d.length)
  );
}
// 获取时间
export function getzshgDate(day) {
  let date = new Date();
  let tempdate = date.getTime() + 1000 * 60 * 60 * 24 * day;
  date.setTime(tempdate);
  return date;
}
export function formate(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  return fmt;
}
export function getUUID() {
  return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  })
}